/**
 * ia-small-batches-slider – web component for Small batches section slider.
 */
(function () {
  class IaSmallBatchesSlider extends HTMLElement {
    connectedCallback() {
      var sectionId = this.getAttribute('data-section-id');
      if (!sectionId) return;

      var swiperEl = document.getElementById('ia-small-batches-' + sectionId + '-swiper');
      var prevEl = document.getElementById('ia-small-batches-' + sectionId + '-prev');
      var nextEl = document.getElementById('ia-small-batches-' + sectionId + '-next');

      if (!swiperEl || typeof Swiper === 'undefined') return;

      var header = this.querySelector('.ia-small-batches__header');
      var headerItems = header ? header.querySelectorAll('.ia-small-batches__header-item') : [];

      function setActiveHeaderItem(realIndex) {
        var itemIndex = realIndex + 1; // 1-based to match data-item-index
        headerItems.forEach(function (el) {
          el.classList.toggle('active', parseInt(el.getAttribute('data-item-index'), 10) === itemIndex);
        });
      }

      this._swiper = new Swiper(swiperEl, {
        slidesPerView: 1.2,
        spaceBetween: 12,
        loop: true,
        breakpoints: {
          768: {
            slidesPerView: 2.2
          },
        },
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl
        },
        on: {
          init: function () {
            setActiveHeaderItem(this.realIndex);
          },
          slideChange: function () {
            setActiveHeaderItem(this.realIndex);
          }
        }
      });
    }

    disconnectedCallback() {
      if (this._swiper) {
        this._swiper.destroy(true, true);
        this._swiper = null;
      }
    }
  }

  if (!customElements.get('ia-small-batches-slider')) {
    customElements.define('ia-small-batches-slider', IaSmallBatchesSlider);
  }
})();
